import { Anchor } from "../../components/ui/anchor/Anchor";
import styled from "../../shared/styled";

export const StyledLogo = styled(({ ...rest }) => <Anchor {...rest} />)`
  display: flex;
  align-items: center;
  position: relative;
  padding: 1px;
  width: 9vw;
  outline: none;
  -webkit-tap-highlight-color: transparent;

  &:focus,
  &:focus-visible,
  &:active {
    outline: none;
    box-shadow: none;
    background: transparent;
  }

  img {
    width: 62%;
    user-select: none;
    -webkit-user-drag: none;
  }
`;
